import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedCycle = {
    id: 1,
    cropId: 8,
    startedAt: '1612874239',
    completedOn: '1612875239'
};
const mock = {
    get: mockedRequester(mockedCycle, 'cycles.get'),
    close: mockedRequester(mockedCycle, 'cycles.close'),
    update: () => mockedRequester(mockedCycle, 'cycles.update'),
    create: () => mockedRequester(mockedCycle, 'cycles.create'),
    getAll: mockedRequester([mockedCycle], 'cycles.getAll'),
    getMany: mockedRequester(mockedPaginatedResponse([mockedCycle]), 'cycles.getMany')
};
export default mock;
